(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('comments', Comments)

    /** @ngInject */
    function Comments($filter, $timeout, HelperService, EventService, MediaService, VideoService, PATHS, ROUTES) {
        function CommentsController() {
            const vm = this;

            let commentsPaginated = [];
            let skip = 0;
            let perPage = 5;

            vm.getCreationDate = comment => {
                var duration = moment.duration(moment().diff(moment(comment.RegistrationDate)));
                var hours = duration.asHours();

                if (hours > 24)
                    return moment(comment.RegistrationDate).format('DD/MM/YYYY HH:mm');

                return $filter('momentTimeAgo')(comment.RegistrationDate);
            }

            vm.getPersonImage = person => {
                if (person.Image)
                    return `${ROUTES.CENTRAL_CONTAS}api/images/res/100/100/person/${person.ExternalId}/${person.Image}`;

                return `${ROUTES.CENTRAL_CONTAS}api/images/res/100/100/placeholder.jpg`;
            }

            vm.loadMoreComments = shouldListAll => {
                vm.isLoading = true;

                skip = skip + perPage;

                if (shouldListAll) {
                    skip = 0;
                    perPage = 9999;
                }

                return getComments(shouldListAll);
            }

            vm.hasSubComments = comment => {
                if (vm.eventId)
                    return comment.EventComment1.length;

                else if (vm.videoId)
                    return comment.VideoComment1.length;

                else if (vm.newsId)
                    return comment.NewsComment1.length;
            }

            vm.showPagination = () => {
                return vm.comments.length >= 2 && vm.comments.length < vm.numberOfComments;
            }

            vm.showSubComments = comment => {
                comment.isSubCommentsActive = true;
            }

            vm.hideSubComments = comment => {
                comment.isSubCommentsActive = false;
            }

            vm.answerComment = comment => {
                let scrollElement = null;

                vm.answeringComment = comment;

                if (comment) {
                    vm.showSubComments(comment);

                    scrollElement = `#response${comment.Id}`;
                } else
                    scrollElement = `#response`;

                $timeout(() => {
                    $('html, body').animate({
                        scrollTop: $(scrollElement).offset().top - 100
                    }, 500);

                    $(`${scrollElement} textarea`).focus();
                })
            }

            vm.init = () => {
                vm.comments = [];
                vm.registerId = 0;
                vm.areaId = 0;
                vm.control = {
                    loadMoreComments: vm.loadMoreComments
                };

                getComments();
            }

            function getComments(shouldListAll) {
                HelperService.startLoading('.comments');

                vm.isLoadingComments = true;
                let parameters = prepareParameters();

                if (vm.eventId) {
                    vm.registerId = vm.eventId;
                    vm.areaId = 1;

                    return EventService
                        .getCommentsByParameters(parameters)
                        .then(success => successCallback(success, shouldListAll), errorCallback)
                } else if (vm.videoId) {
                    vm.registerId = vm.videoId;
                    vm.areaId = 2;

                    return VideoService
                        .getCommentsByParameters(parameters)
                        .then(success => successCallback(success, shouldListAll), errorCallback)
                } else if (vm.newsId) {
                    vm.registerId = vm.newsId;
                    vm.areaId = 3;

                    return MediaService
                        .getCommentsByParameters(parameters)
                        .then(success => successCallback(success, shouldListAll), errorCallback)
                }
            }

            function prepareParameters() {
                let params = {
                    Skip: skip,
                    PerPage: perPage,
                    Approved: true,
                    OrderBy: 'RegistrationDate',
                    OrderByDescending: false
                }

                if (vm.eventId) {
                    params.SearchField = 'EventId';
                    params.SearchQuery = vm.eventId;
                } else if (vm.videoId) {
                    params.SearchField = 'VideoId';
                    params.SearchQuery = vm.videoId;
                } else if (vm.newsId) {
                    params.SearchField = 'NewsId';
                    params.SearchQuery = vm.newsId;
                }

                return params;
            }

            function successCallback(success, shouldListAll) {
                commentsPaginated = success.Comments;

                for (let index = 0; index < commentsPaginated.length; index++) {
                    const comment = commentsPaginated[index];

                    if (vm.eventId) {
                        comment.Children = comment.EventComment1;
                    } else if (vm.videoId) {
                        comment.Children = comment.VideoComment1;
                    } else if (vm.newsId) {
                        comment.Children = comment.NewsComment1;
                    }
                }

                if (!commentsPaginated.length || shouldListAll)
                    vm.comments = [];

                for (let index = 0; index < commentsPaginated.length; index++)
                    vm.comments.push(commentsPaginated[index]);

                vm.comments.sort(function (a, b) {
                    return new Date(a.RegistrationDate) - new Date(b.RegistrationDate);
                });

                vm.numberOfComments = success.NumberOfComments;
                vm.isLoadingComments = false;

                HelperService.stopLoading('.comments');
            }

            function errorCallback(error) {
                HelperService.errorCallback(error);
            }
        }

        function link(scope, attrs, elem, ctrl) {
            ctrl.init();
        }

        return {
            bindToController: true,
            link: link,
            controller: CommentsController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/comments/comments.html`,
            scope: {
                eventId: '=',
                videoId: '=',
                newsId: '='
            }
        }
    }
}());